<template>
    <!-- Container principal -->
    <div
      class="mx-auto p-4 bg-[var(--fundoApp)] text-[var(--text)] rounded-[10px] w-full h-auto"
    >
      <!-- Em telas md (médias) ou maiores, usamos flex-row; caso contrário, fica flex-col -->
      <div class="flex flex-col md:flex-row gap-4">
        
        <!-- Coluna da esquerda -->
        <div class="flex flex-col gap-2 md:w-1/3">
          <div class="flex gap-2 items-center">
            <h1 class="text-[var(--titulo)]">
              Adicionar {{ data.title }}
            </h1>
          </div>
  
          <div class="flex gap-2">
            <AppButton
              :visibility="true"
              emitType="select"
              left_icon="fa-solid fa-circle-plus fa-2xl"
              @select="clear_inputs"
              :font_size="12"
              style="color: var(--label); background-color: var(--button);"
              :text="'Novo/a ' + data.entity_type"
            />
          </div>
  
          <div
            v-for="(value, key) in item"
            :key="key"
          >
            <div
              v-if="key !== 'id'"
              class="flex flex-col text-[var(--text)] capitalize"
            >
              <label :for="key">{{ key }}:</label>
              <input
              style="color: var(--text); background-color: var(--label);"
                class="text-black text-sm border-1 border-[#ccc] p-1 rounded-[5px]"
                :type="getInputType(value)"
                v-model="item[key]"
                :placeholder="key"
              />
            </div>
          </div>
  
          <div
            class="set_data_container rounded-[10px] flex flex-col gap-2 p-2 bg-[var(--fundoForm)] capitalize"
          >
            <div
              v-for="(value, key) in set_data_copy"
              :key="key"
              class="ser_data flex items-center gap-2"
            >
              <label class="min-w-[10px]">
                {{ key }}:
              </label>
              <div class="flex items-center gap-2 text-[var(--icon)]">
                <span>
                  {{ value.nome ? value.nome : value.numero }}
                </span>
                <button
                  v-if="types[key]"
                  @click="open_generic_table(key)"
                  :style="{ color: 'var(--icon)', cursor: 'pointer' }"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
              </div>
            </div>
          </div>
  
          <AppButton
            class="capitalize"
            v-if="!this?.data?.dependency && data.entity_type=='pedido'"
            v-bind:visibility="true"
            :font_size="12"
            color="var(--button)"
            left_icon="fa-solid fa-pen-to-square"
            text="Proposta"
            emitType="select"
            @select="open_generic_table('proposta')"
          />
  
          <button
            class="bg-[var(--button)] py-2 text-[var(--text)] rounded-[10px]"
            @click.prevent="add_data"
          >
            {{ data_create ? 'Adicionar' : 'Atualizar' }}
          </button>
          
          <button
            v-if="!data_create"
            class="bg-[var(--obrigatorio)] py-2 text-[var(--text)] rounded-[10px]"
            @click.prevent="delete_data"
          >
            Eliminar
          </button>
  
          <button
            v-if="this?.data?.dependency"
            class="bg-[var(--icon)] py-2 text-[var(--text)] rounded-[10px]"
            @click.prevent="return_to_tab"
          >
            Salvar e Voltar
          </button>
        </div>
        
        <!-- Coluna da direita -->
        <div class="flex flex-col gap-2 p-2 w-full md:w-2/3">
          <div class="flex self-end gap-2 items-center">
            <AppButton
              v-if="save_and_return"
              v-bind:visibility="true"
              :font_size="12"
              style="color: var(--label); background-color: var(--titulo);"
              left_icon="fa-solid fa-pen-to-square"
              text="Salvar"
              emitType="select"
              @select="save_entity"
            />
            <AppButton
              class="text-[var(--text)]"
              v-bind:visibility="true"
              left_icon="fa-regular fa-circle-xmark fa-xl"
              emitType="close"
              @close="close"
              :width="23"
              :height="23"
            />
          </div>
  
          <div
            v-if="with_address"
            class="flex gap-2 items-center flex-wrap"
          >
            <label for="address" class="whitespace-nowrap">
              Endereço:
            </label>
            <h3 class="text-[var(--icon)]">
              {{ address_is_empty(address) ? 'Não Atribuído' : address.pais + ',..' }}
            </h3>
            <AppButton
              v-bind:visibility="true"
              :font_size="8"
              color="#9797EF"
              left_icon="fa-solid fa-pen-to-square"
              text="Mapa"
              emitType="select"
              @select="show_map = true"
            />
          </div>
  
          <AppAddressMap
            v-if="show_map"
            :initialAddress="address"
            @close="close_map"
            @save="update_address"
          />
  
          <AppTable
            visibility="true"
            :show="!show_map"
            :table_data="items"
            :table_title="data.title"
            @row-clicked="select_data"
            :show_multiSelect="false"
          />
  
          <AppTable
            visibility="true"
            :show="!show_map && show_generic_table"
            :table_data="generic_table_data"
            :table_title="generic_table_title"
            @row-clicked="select_generic_data"
            :show_multiSelect="false"
            :page_display="5"
            @close="show_generic_table = false"
          />
        </div>
      </div>
    </div>
  </template>

<script>
import { id as loggedID } from '@/extraData'
import axios from 'axios';
import AppTable from './tables/table.vue'
import AppButton from './updated/button.vue'
import AppAddressMap from './addressMap.vue'
import { toast } from 'vue3-toastify';

export default {
    name: 'genericCRUD',
    components: {
        AppButton,
        AppTable,
        AppAddressMap,
    },
    props: {
        data: {
            type: Array,
            default: []
        },
        model: {
            type: Object,
        },
        types: {
            type: Object,
            default: {}
        },
        set_data: {
            type: Object,
            default: {}
        },
        set_id: {
            type: Object,
            default: {}
        },

        with_address: {
            type: Boolean,
            default: false
        },
        tab_mode: {
            type: Boolean,
            default: false
        },

        save_and_return: {
            type: Boolean,
            default: false
        }


    },
    data() {
        return {
            loggedID: loggedID,
            items: [],
            set_data_copy: JSON.parse(JSON.stringify(this.set_data)),
            item: JSON.parse(JSON.stringify(this.model)),
            current_item: {},
            data_create: true,
            show_generic_table: false,
            generic_table_title: '',
            generic_table_data: [],
            baseURl: process.env.VUE_APP_URL_BASE,
            address: {
                pais: '',
                morada: '',
                codigoPostal: '',
                freguesia: '',
                localidade: '',
                latitude: '',
                longitude: '',
                concelho: '',
                distrito: '',
            },
            show_map: false,


            current_return_entity: {}


            // entity_type_uppercase: this.data.entity_type.charAt(0).toUpperCase() + this.data.entity_type.slice(1),
            // data
        }
    },
    created() {
        // this.create_url= `${this.baseURl}/api/v1/${this.entity_type}/registrar/`
        // console.log("create_url:",this.create_url)
        // this.select_url= `${this.baseURl}/api/v1/${this.entity_type}/`,
        // console.log("select_url:",this.select_url)
        // this.select_owner_url= `${this.baseURl}/api/v1/${this.owner.type}/${this.owner.id}/?${this.entity_type}_only=true/`,
        // console.log("select_owner_url:",this.select_owner_url)
        // this.update_url= `${this.baseURl}/api/v1/${this.entity_type}/editar`,
        // console.log("update_url:",this.update_url)
        // this.delete_url= `${this.baseURl}/api/v1/${this.entity_type}/eliminar`,
        // console.log("delete_url:",this.delete_url)

        console.log("item", this.item)
        this.get_datas();
    },


    methods: {

        async create(data, url) {
            try {
                const res = await axios.post(url, data);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },

        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },

        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;

            } catch (error) {
                console.error('Error getting data:', error);
            }

        },

        async update(url, data) {

            try {
                const res = await axios.put(url, data);
                console.log('Data successfully updated:', res.data);
                return res.data.data;

            } catch (error) {
                console.error('Error posting data:', error);
            }
        },

        async remove(url) {
            // console.log("Data:", data.id)
            try {
                await axios.delete(url);
                return true;
            } catch (error) {
                console.error('Error deleting data:', error);
            }
        },

        getInputType(value) {
            return typeof value === 'number' ? 'number' : 'text';
        },

        async get_datas() {
            const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

            // if(this.items){
            //     this.items = []
            // }

            this.items = await this.select_all(this.data.rotas.select_all_url)

            if (this.data.entity_type == 'armazem') {
                const filtered_items = this.items.map(obj =>
                    Object.fromEntries(
                        Object.entries(obj).filter(([key]) => ["id", "nome", "descricao", "tipo", "zona", "endereco"].includes(key))
                    )
                );
                filtered_items.forEach(item => {
                    if (item.endereco) {
                        item.endereco = item.endereco.pais ? item.endereco.pais : 'N/A'
                    }
                });
                this.items = filtered_items.sort((a, b) => a.id - b.id)
            }
            else this.items = this.items.sort((a, b) => a.id - b.id)


        },

        async add_data() {
            const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

            // if(this.item.tipos){
            //     delete this.item.tipos;
            // }

            // if(this.item.tipo){
            //     let entity_type = this.entity_type_uppercase;
            //     this.item['tp' + entity_type + '_id'] = this.item.tipo;
            //     delete this.item.tipo;
            // }
            for (let key in this.set_data_copy) {

                if (this.set_id.hasOwnProperty(key)) {
                    this.item[this.set_id[key]] = this.set_data_copy[key].id

                }

            }
            if (!this.data.owner.mulTitable && this.item.id == 0) {
                this.item[this.data.owner.key_name] = this.data.owner.id;
            }

            console.log("item to crete:", this.item)

            if (this.item.id == 0) {
                console.log('inside create', this.item)
                delete this.item.id;
                const res = await this.create(this.item, this.data.rotas.create_url)
                if (res) {
                    console.log("entity created:", res)
                    this.current_item = JSON.parse(JSON.stringify(res))
                    if (this.with_address) {
                        await this.manage_entity_address('create', res, this.data.entity_type)
                    }
                    console.log("item created:", res)
                    if (this.data.owner.multiTable && this.data.owner && !isEmptyObject(this.data.owner)) {
                        await this.create_owner_entity(res)
                    }

                    else {


                        toast.success(`${this.data.entity_type} criado com sucesso!`, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                        });

                    }
                    this.clear_inputs()
                    await this.get_datas()
                }
            }
            else {
                const res = await this.update(`${this.data.rotas.update_url}/${this.item.id}/`, this.item)
                if (res) {
                    console.log("entity updated:", res)
                    this.current_item = JSON.parse(JSON.stringify(res))
                    if (this.with_address) {
                        await this.manage_entity_address('update', res, this.data.entity_type)
                    }
                    this.clear_inputs()
                    toast.success(`${this.data.entity_type} atualizado com sucesso!`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1000,
                    });
                    await this.get_datas()
                }
            }
        },

        async select_data(item) {
            console.log("item selected:", item)
            const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

            this.current_return_entity = JSON.parse(JSON.stringify(item));

            const entity = await this.select(`${this.data.rotas.select_url}${item.id}/`)
            console.log("entity:", entity)
            this.data_create = false;
            const current_item = JSON.parse(JSON.stringify(entity))



            for (let key in this.set_data_copy) {

                if (current_item.hasOwnProperty(key)) {
                    this.set_data_copy[key] = current_item[key];
                }
            }





            // if(current_item.tipo){
            //     current_item.tipos = this.model.tipos;
            //     current_item.tipo=current_item.tipo.id
            // }


            if (current_item.endereco) {
                this.address = JSON.parse(JSON.stringify(current_item.endereco));
                if (isEmptyObject(this.address)) {
                    this.address.id = 0;
                }
                console.log("address:", this.address)
            }



            //this.deleteKeys(current_item);
            for (let key in current_item) {
                if (!this.item.hasOwnProperty(key)) {
                    delete current_item[key];
                }
            }

            console.log("table final item:", current_item)
            this.item = JSON.parse(JSON.stringify(current_item))
            this.current_item = JSON.parse(JSON.stringify(current_item))
        },

        async delete_data() {
            const res = await this.remove(`${this.data.rotas.delete_url}/${this.item.id}/`)
            if (res) {
                console.log("item deleted:", res)
                toast.success(`${this.data.entity_type} eliminado com sucesso!`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1000,
                });
                this.clear_inputs()

                await this.get_datas()
            }
        },

        clear_inputs() {
            this.item = JSON.parse(JSON.stringify(this.model))
            this.set_data_copy = JSON.parse(JSON.stringify(this.set_data))

            this.address = {
                pais: '',
                morada: '',
                codigoPostal: '',
                freguesia: '',
                localidade: '',
                latitude: '',
                longitude: '',
                concelho: '',
            }
            this.data_create = true
        },

        close() {
            this.$emit('close')
        },

        updateTipo(event) {
            console.log("choice:", event.target.value)
            // this.item['tipo'] = event.target.value;
            console.log(this.item['tipo'])
        },

        async create_owner_entity(data) {
            //console.log(`${this.owner.type} ${this.entity_type} to create:`,data)
            const create_data = {}
            create_data[this.data.key_name] = data.id;
            create_data[this.data.owner.key_name] = this.data.owner.id;

            // if(data['tp' + this.entity_type_uppercase + '_id']) 
            //     create_data.tipo_id=data['tp' + this.entity_type_uppercase + '_id']

            const res = await this.create(create_data, this.data.owner.rotas.create_url);
            if (res) {
                console.log("fornecedor contacto created", res)
                toast.success(`${this.data.entity_type} do/a ${this.data.owner.type} criado com sucesso`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1000,
                });
            }
            else {
                toast.error(`Erro ao adicionar ${this.data.entity_type}`, {
                    autoClose: 1000,
                });
            }
            // this.fornecedor_contactos.push(data);
        },


        update_address(data) {
            console.log("parent address:", data)
            this.address = JSON.parse(JSON.stringify(data));
            this.close_map();
        },

        close_map() {
            this.show_map = false;
        },

        deleteKeys(obj) {
            Object.keys(obj).forEach((key) => {
                if (key.includes('tp') || key.includes('_id') || key.includes('foto') || key.includes('endereco')) {
                    delete obj[key];
                }
            });
        },

        async manage_entity_address(action, entity, entity_name) {
            console.log("endereco to create/update:", this.address)
            console.log("entity to update:", entity)
            if (action == 'create') {
                delete this.address.id;
                const res = await this.create(this.address, `${this.baseURl}/api/v1/endereco/registrar/`);
                if (res) {
                    console.log("endereco created:", res)
                    const updated_entity = await this.update(`${this.baseURl}/api/v1/${entity_name}/editar/${entity.id}/`, { nome: entity?.nome ? entity.nome : '', endereco_id: res.id });
                    if (updated_entity) {
                        console.log(`${entity_name} updated`, updated_entity)

                    }
                    // console.log("endereco created",res)
                    // toast.success("Endereço criado com sucesso",{
                    //     position: toast.POSITION.TOP_CENTER,
                    //     autoClose: 1000,
                    // });
                    // this.fornecedor_setData.endereco=res;
                    // this.close_address();
                }
                else {
                    toast.error("Erro ao criar endereço", {
                        autoClose: 1000,
                    });
                }
            }
            else if (action == 'update') {
                console.log(`${entity_name} to update:`, entity)
                if (this.address.id == 0) {
                    const res = await this.create(this.address, `${this.baseURl}/api/v1/endereco/registrar/`);
                    if (res) {
                        console.log("endereco created:", res)
                        const updated_entity = await this.update(`${this.baseURl}/api/v1/${entity_name}/editar/${entity.id}/`, { nome: entity?.nome ? entity.nome : '', endereco_id: res.id });
                        if (updated_entity) {
                            console.log(`${entity_name} updated`, updated_entity)
                        }
                        else {
                            toast.error(`Erro ao Criar endereço do/a ${entity_name}`, {
                                autoClose: 1000,
                            });

                        }
                    }
                    else {
                        toast.error("Erro ao Criar endereço", {
                            autoClose: 1000,
                        });
                    }
                }
                else {
                    const res = await this.update(`${this.baseURl}/api/v1/endereco/editar/${this.address.id}/`, this.address);
                    console
                    if (res) {
                        console.log("endereco updated", res)

                    }
                    else {
                        toast.error("Erro ao atualizar endereço", {
                            autoClose: 1000,
                        });
                    }
                }
            }
        },
        address_is_empty(address) {
            const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

            if (isEmptyObject(address)) {
                return true;
            }
            return Object.values(address).every(x => (x === null || x === ''));
        },

        select_generic_data(item) {
            console.log("item selected:", item)
            this.set_data_copy[this.generic_table_title] = item;
            this.show_generic_table = false;
        },

        open_generic_table(key) {
            if (key == 'proposta') {
                this.$emit('open_proposta', 'proposta',this.data.entity_type)
                return
            }

            this.show_generic_table = true;
            this.generic_table_title = key;
            this.generic_table_data = this.types[key];

        },

        return_to_tab() {
            this.$emit('dependency_created',this.data.entity_type,this.current_item)
        },

        save_entity() {
            this.$emit('save_entity', this.current_item)
        }

    },

    watch: {

        data: {
            handler() {

                if (!this.tab_mode) {

                    this.get_datas()
                    this.item = JSON.parse(JSON.stringify(this.model))
                    this.set_data_copy = JSON.parse(JSON.stringify(this.set_data))
                }
                //this.items = [...this.data]

                else {

                }


            },
            deep: true
        },
        set_data: {
            handler() {
                if (this.tab_mode) {
                    this.set_data_copy['proposta']=this.set_data['proposta']
                }
            },
            deep: true
        }
        // model: {
        //     handler() {
        //         // console.log('cart updated')
        //         this.item = JSON.parse(JSON.stringify(this.model))

        //     },
        //     deep: true
        // }
    },
}


</script>





<style scoped>
.ser_data {
    flex-wrap: wrap;
}
</style>